<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="20">
        <!--检索条件-->
        <el-form class="search" label-suffix="：" :inline="true" size="mini" :model="search">
          <el-form-item label="门店/门诊">
            <el-select
              v-model="search.shop_id"
              clearable
              remote
              filterable
              :remote-method="remoteMethod"
              placeholder="请输入"
              class="w120"
            >
              <el-option
                v-for="item in options.shop_id"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="顾客姓名">
            <el-input
              v-model="search.customer_name"
              maxlength="30"
              class="w120"
              placeholder="请输入"
              clearable
            />
          </el-form-item>

          <el-form-item label="手机号">
            <el-input
              v-model="search.telephone"
              maxlength="11"
              class="w120"
              placeholder="请输入手机号"
              clearable
            />
          </el-form-item>

          <el-form-item label="护理师">
            <el-input
              v-model="search.person_name"
              class="w120"
              placeholder="护理师姓名"
              clearable
            />
          </el-form-item>

          <el-form-item label="预测时间段">
            <el-date-picker
              v-model="search.appointment_time_range"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="w240"
              clearable
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        <el-button type="primary" icon="el-icon-download" size="mini" @click="exportData">导出</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            v-loading="loading"
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <el-table-column prop="id" label="序号" width="60" align="center" />
            <el-table-column label="客户姓名" prop="customer_name" />
            <el-table-column label="电话" prop="telephone"/>
            <el-table-column label="首次到店时间" prop="first_enter_time"/>
            <el-table-column label="归属门店" prop="shop_name"/>
            <el-table-column label="归属护理师" prop="person_name"/>
            <el-table-column label="累计消耗本金" width="120" prop="consume_sum"/>
            <el-table-column label="近90天内核销时间" width="170" prop="first_service_time"/>
            <el-table-column label="末次核销时间" width="170" prop="last_service_time"/>
            <el-table-column label="护理次数" prop="search_service_num"/>
            <el-table-column label="核销天数" width="110" prop="search_enter_store_day"/>
            <el-table-column label="预测下次到店时间" width="180" prop="appointment_time"/>
            <el-table-column label="预测间隔天数" width="110" prop="predicted_interval_days"/>
            <el-table-column label="顾客状态" prop="customer_status"/>
            <el-table-column label="预估距今天数" prop="day_diff"/>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getServiceList } from "@/api/client";
import pagination from "@/components/Pagination";
import { getShopList } from "@/api/shop";

class Search {
  shop_id = "";
  customer_name = "";
  telephone = "";
  person_name = ""; // 护理师姓名
  appointment_time_range = []; // 预测时间段日期范围
}
class Page {
  total = 0;
  page = 1;
  limit = 10;
}
class Options {
  shop_id = [];
}
export default {
  name: "PointList",
  components: {
    pagination
  },
  data() {
    return {
      search: new Search(),
      page: new Page(),
      options: new Options(),
      list: [],
      loading: false,
    };
  },
  mounted() {
    this.getList();
    this.remoteMethod("");
  },
  methods: {
    
    getList(option) {
      this.loading = true;
      if (option === "search") this.page = new Page();

      // 组装参数，拆分日期区间传给后端
      const params = { ...this.search, page: this.page.page, limit: this.page.limit };
      if (params.appointment_time_range && params.appointment_time_range.length === 2) {
        params.start_time = params.appointment_time_range[0];
        params.end_time = params.appointment_time_range[1];
      } else {
        params.start_time = "";
        params.end_time = "";
      }
      // 删除range字段，避免后端接收多余参数
      delete params.appointment_time_range;

      getServiceList(params).then(
        res => {
          this.list = res.list;
          this.page.total = res.dataCount;
          this.loading = false;
        }
      ).catch(()=>{
        this.loading = false;
      })
    },
    exportData() {
      getServiceList({...this.search, export: 1 }).then(res => {
        window.open(res.url);
        console.log(res);
      })
    },

    // 搜索门店
    remoteMethod(e) {
      getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
        this.options.shop_id = res.list;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.w84 {
  width: 84px;
}
.w100 {
  width: 100px;
}
.w120 {
  width: 120px;
}
.w240 {
  width: 240px;
}
</style>